import { render, staticRenderFns } from "./RootUser.vue?vue&type=template&id=14d537cd"
import script from "./RootUser.vue?vue&type=script&lang=js"
export * from "./RootUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports